module.exports = __webpack_public_path__ + "img/puzzle_2.610a09cb.png";